import { GenericLink } from '@core/models/types/generic-link.type';

export const termosInformacao: GenericLink[] = [
  {
    title: 'Política de Privacidade',
    url: '/politicas-e-termos/politica-de-privacidade.html',
  },
  {
    title: 'Política de Cookies',
    url: '/politicas-e-termos/politica-de-cookies.html',
  },
  {
    title: 'Condições Gerais Tele Prêmios da Sorte',
    url: '/politicas-e-termos/condicoes-gerais/885',
  },
  {
    title: 'Condições Gerais Tele Prêmios da Sorte Max',
    url: '/politicas-e-termos/condicoes-gerais/1090',
  },
  {
    title: 'Termos de Uso',
    url: '/politicas-e-termos/termos-de-uso.html',
  },
  {
    title: 'Termos Legais',
    url: '/politicas-e-termos/termos-legais.html',
  },
];

export const DPO_LINK =
  'https://sbt-privacidade.my.onetrust.com/webform/2b81d028-2171-49c6-9544-4bd2c1dd7efa/b69fbfd0-95b5-4997-8dce-8f4e480ab2dc';
